import { ClientPropertySelfUploadPopupContext } from './ClientPropertySelfUploadPopup.context'
import { ClientPropertySelfUploadPopupController } from './ClientPropertySelfUploadPopup.controller'
import { DynamicFlowProvider } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { useParams } from 'react-router-dom'

/**
 * @component ClientPropertySelfUploadPopup 
 * @example
 * <ClientPropertySelfUploadPopup />
 */
export const ClientPropertySelfUploadPopup: FC = () => {
  const { id } = useParams<{ id?: string }>() // TODO: Will be updated when BE is ready

  if (!id) return null

  return (
    <DynamicFlowProvider>
      <ClientPropertySelfUploadPopupContext assignmentId={id}>
        <ClientPropertySelfUploadPopupController />
      </ClientPropertySelfUploadPopupContext>
    </DynamicFlowProvider>
  )
}
